"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MomentPlayersAndTags = void 0;

var _index = require("../../index");

require("./MomentPlayersAndTags.css");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Moment Player and Tags
var MomentPlayersAndTags = function MomentPlayersAndTags(_ref) {
  var players = _ref.players,
      tags = _ref.tags;
  return /*#__PURE__*/_react.default.createElement(_index.Row, {
    className: "MomentPlayersAndTags"
  }, players && players.map(function (player, idx) {
    // Get the user, imageUrl, and initials
    var user = player.user;
    var playerImageUrl = user ? "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/avatars?user=").concat(user.user_id) : null;
    var playerInitials = user ? (0, _index.getInitials)(user.first_name, user.last_name) : "";
    return /*#__PURE__*/_react.default.createElement(_index.Avatar, {
      size: 24,
      key: "pa-".concat(player.name, "-").concat(idx),
      imageUrl: playerImageUrl,
      initials: playerInitials,
      marginTop: 2,
      marginRight: 1,
      background: _index.Color.Charcoal50,
      color: _index.Color.White
    });
  }), tags && tags.map(function (tag, idx) {
    return /*#__PURE__*/_react.default.createElement(_index.TagChip, {
      key: "tc-personal-".concat(tag.name, "-").concat(idx),
      category: "personal",
      tag: tag,
      marginTop: 2,
      marginRight: 1
    });
  }));
};

exports.MomentPlayersAndTags = MomentPlayersAndTags;